export const USER_INFORMATION_TEST_ID = 'USER_INFORMATION_TEST_ID';
export const REFRESH_BUTTON_TEST_ID = 'refresh-button';
export const TARGETINGS_COMPONENT_ID = 'targetings-component';
export const WARNING_ID = 'Warning-component';
export const CAMPAIGN_STATUS_ICON_ID = 'campaign-status-icon';
export const WEB_SDK_CAMPAIGN_SEGMENT_STATUS_ID = 'web-sdk-campaign-segment-status';
export const WEB_SDK_CAMPAIGN_STATUS_ICON_ID = 'web-sdk-campaign-status-icon';
export const WEB_SDK_CAMPAIGN_DISPLAY_BUTTON_ID = 'web-sdk-campaign-display-button';
